// extracted by mini-css-extract-plugin
export var assigneeBadge = "_m6-0";
export var assigneeDetails = "_m6-1";
export var assigneeInfo = "_m6-2";
export var dropdownContainer = "_m6-4";
export var dropdownImage = "_m6-5";
export var editAssigneeInfo = "_m6-3";
export var editAssigneeModalContainer = "_m6-6";
export var hidden = "_m6-8";
export var input = "_m6-7";